import { render } from "./MyGrade.vue?vue&type=template&id=7625c464&ts=true"
import script from "./MyGrade.vue?vue&type=script&lang=ts"
export * from "./MyGrade.vue?vue&type=script&lang=ts"

import "./MyGrade.vue?vue&type=style&index=0&id=7625c464&lang=scss"

import exportComponent from "/builds/rahmet/products/grading-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__